import { connect } from 'react-redux';

import { changeComposeContentType } from '../../../actions/compose';
import MarkdownButton from '../components/markdown_button';

const mapStateToProps = state => ({
  active: state.getIn(['compose', 'content_type']) === 'text/markdown',
});

const mapDispatchToProps = dispatch => ({

  onClick () {
    dispatch((_, getState) => {
      const isMarkdown = getState().getIn(['compose', 'content_type']) === 'text/markdown';
      dispatch(changeComposeContentType(isMarkdown ? 'text/plain' : 'text/markdown'));
    });
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(MarkdownButton);
